import getDefaultState from './state';

export function flush(state) {
  Object.assign(state, getDefaultState());
}

export function updateAttributes(state, { attributes, key }) {
  attributes.sort((a, b) => new Intl.Collator('is').compare(a.value, b.value));
  state[key] = attributes;
}

export function updateMeta(state, { meta }) {
  state.meta = meta;
}
